import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenService } from 'src/app/token.service';

@Component({
  selector: 'app-modal-exibir-contador',
  templateUrl: './modal-exibir-contador.component.html',
  styleUrls: ['./modal-exibir-contador.component.scss']
})
export class ModalExibirContadorComponent implements OnInit {

  @Input() contador: any;
  public telefone: any;
  public ufContabilista: any;
  public seqCRCFull: string;
  public seqCRC: string;
  
  constructor(
    public activeModal: NgbActiveModal,
    private tokenService: TokenService
    ) { }
    
    ngOnInit() {
    this.tokenService.canActivate();
    this.telefone = this.contador.contato.dddTelefone1 + this.contador.contato.telefone1;
    this.ufContabilista = this.contador.ufCrc;
    this.seqCRCFull = this.contador.seqCrc;
    this.seqCRC = this.contador.seqCrc.substring(3, 10);
  }

}
